export class OverlayStyle {
  overlayStyle = '';
  padding = '';
  margin = '';
  maxWidth = '';
  transition = '';
  position = 'uk-position-bottom';

  static normalize(styles: Partial<OverlayStyle>): OverlayStyle {
    const pureStyles = new OverlayStyle();

    pureStyles.overlayStyle = styles.overlayStyle ?? pureStyles.overlayStyle;
    pureStyles.padding = styles.padding ?? pureStyles.padding;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.position = styles.position ?? pureStyles.position;

    return pureStyles;
  }
}
